function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23.309 37.245a1.5 1.5 0 002.12 0l9.547-9.546a1.5 1.5 0 10-2.121-2.121l-8.486 8.485-8.485-8.485a1.5 1.5 0 10-2.121 2.121l9.546 9.546zm-.44-24.691v23.63h3v-23.63h-3z",
  fill: "#63C"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 23,
  stroke: "#63C",
  strokeWidth: 2
});

function SvgDownloadBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDggNDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aAogICAgICAgIGQ9Ik0yMy4zMDg2IDM3LjI0NTNDMjMuODk0NCAzNy44MzEgMjQuODQ0MSAzNy44MzEgMjUuNDI5OSAzNy4yNDUzTDM0Ljk3NTkgMjcuNjk5M0MzNS41NjE3IDI3LjExMzUgMzUuNTYxNyAyNi4xNjM4IDM0Ljk3NTkgMjUuNTc4QzM0LjM5MDEgMjQuOTkyMiAzMy40NDAzIDI0Ljk5MjIgMzIuODU0NSAyNS41NzhMMjQuMzY5MyAzNC4wNjMzTDE1Ljg4NCAyNS41NzhDMTUuMjk4MiAyNC45OTIyIDE0LjM0ODQgMjQuOTkyMiAxMy43NjI3IDI1LjU3OEMxMy4xNzY5IDI2LjE2MzggMTMuMTc2OSAyNy4xMTM1IDEzLjc2MjcgMjcuNjk5M0wyMy4zMDg2IDM3LjI0NTNaTTIyLjg2OTMgMTIuNTUzOEwyMi44NjkzIDM2LjE4NDZMMjUuODY5MyAzNi4xODQ2TDI1Ljg2OTMgMTIuNTUzOEwyMi44NjkzIDEyLjU1MzhaIgogICAgICAgIGZpbGw9IiM2NjMzQ0MiIC8+CiAgICA8Y2lyY2xlIGN4PSIyNCIgY3k9IjI0IiByPSIyMyIgc3Ryb2tlPSIjNjYzM0NDIiBzdHJva2Utd2lkdGg9IjIiIC8+Cjwvc3ZnPgogICAg";
export { SvgDownloadBook as ReactComponent };